<template>
  <form ref="order_payment">
    <div class="card__header">
      <p class="card__title">Check recipient address</p>
      <p class="card__subtitle">
        Enter the recipient details and check if their address is in the delivery area.
      </p>
    </div>
    <div class="card__content">
      <div class="form">
        <div class="form__field form__field--md6">
          <label for="firstname" class="form__label">Recipient name</label>
          <input type="text" name="firstname" id="firstname" class="form__control form-field required" v-model="$parent.address.firstname">
        </div>
        <div class="form__field form__field--md6">
          <label for="lastname" class="form__label">Recipient surname</label>
          <input type="text" name="lastname" id="lastname" class="form__control form-field required" v-model="$parent.address.lastname">
        </div>
        <div class="form__field">
          <label for="address" class="form__label">Enter recipient postcode</label>
          <div id="postcode_lookup"></div>
        </div>
        <div class="form__field">
          <label for="address_building-type" class="form__label">Building type</label>
          <select v-model="$parent.address.building_type" name="address_building-type" id="address_building-type" class="form__control">
            <option value="house">House</option>
            <option value="flat">Flat</option>
            <option value="office">Office</option>
            <option value="shop">Shop</option>
          </select>
        </div>
        <div class="form__field">
          <label for="address_comments" class="form__label">Comments</label>
          <input v-model="$parent.address.comment" type="text" name="address_comments" id="address_comments" class="form__control">
          <div class="form__notice">
            Flat number for a building, building code, etc.
          </div>
        </div>
      </div>

      <div v-if="errors.length" class="form__notice form__notice--error mt-3">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </div>
    </div>
    <div v-if="$parent.loading">
      <popup-loader></popup-loader>
    </div>
    <div class="card__actions">
      <button type="button" class="button button--md button--secondary" v-on:click="checkAddress()">Next</button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      errors: [],
    }
  },
  mounted() {
    window.getAddress.find(
        'postcode_lookup',
        window.config.getaddress_token,
        {
          input: {
            id:'address',
            name:'address',
            class:'form__control form-field required',
            label:'e.g. W12 0FD',
          },
          button:{
            class:'button button--md button--grey',
            label:'Search',
          },
          dropdown:{
            id:'address-select',
            class:'form__control form-field required',
            select_message:'Select recipient address',
          },
        }
    );

    document.addEventListener("getaddress-find-address-selected", function(e){
      const {
        thoroughfare,
        building_name,
        sub_building_name,
        sub_building_number,
        building_number,
        line_1,
        line_2,
        line_3,
        town_or_city,
        postcode,
        latitude,
        longitude,
      } = e.address;

      this.$parent.address = {
        ...this.$parent.address,
        building_type: line_1.toLowerCase().includes('flat') ? 'flat' : 'house',
        thoroughfare,
        building_name,
        sub_building_name,
        sub_building_number,
        building_number,
        line_1,
        line_2,
        line_3,
        city: town_or_city,
        postcode,
        coordinates: {
          latitude,
          longitude,
        },
      };

      this.handleNameChange();
    }.bind(this))

    document.querySelector('input#address').value = this.$parent.address.postcode;
  },

  methods: {
    handleNameChange() {
      this.$parent.addressHasChanged = true;
      this.$parent.date = null;
      this.$parent.slot = '';
    },

    checkAddress() {
      this.errors = [];

      if (!this.$parent.address.firstname) {
        this.errors.push('Name is required.');
      }
      if (!this.$parent.address.lastname) {
        this.errors.push('Surname is required.');
      }
      if (!this.$parent.address.postcode) {
        this.errors.push('Address is required.');
      }

      if (this.errors.length === 0) {
        axios.post('/api/address/verify', {
          postcode: this.$parent.address.postcode
        })
          .then(function (response) {
            if (response.data.canBeDelivered === true) {
              this.$parent.step = 'NEW';
            } else {
              this.$parent.step = 'ADDRESS-FAIL';
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  }
}
</script>
